import { render, staticRenderFns } from "./user-tasks.vue?vue&type=template&id=76d37075"
import script from "./user-tasks.vue?vue&type=script&lang=js"
export * from "./user-tasks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports